<app-layout-default>
  <ss-cookie-consent-form>
  </ss-cookie-consent-form>
</app-layout-default>

<!-- <lcp-footer></lcp-footer> -->